import { ListXIcon } from 'lucide-react';

import { Empty, EmptyMedia, EmptyTitle } from '@/components/ui/empty';
import { cn } from '@/lib/utils';

interface FilterEmptyStateProps {
  text: string;
  className?: string;
}

export const FilterEmptyState = ({ text, className }: FilterEmptyStateProps) => (
  <Empty className={cn('gap-2 p-4', className)}>
    <EmptyMedia variant="icon" className="size-6">
      <ListXIcon className="size-4 text-muted-foreground" aria-hidden />
    </EmptyMedia>
    <EmptyTitle className="text-sm font-normal text-muted-foreground">{text}</EmptyTitle>
  </Empty>
);
